<script setup lang="ts">
    import {
        AlertDialog,
        AlertDialogAction,
        AlertDialogCancel,
        AlertDialogContent,
        AlertDialogDescription,
        AlertDialogFooter,
        AlertDialogHeader,
        AlertDialogTitle,
    } from '@/components/ui/alert-dialog';
    import { useI18n } from 'vue-i18n';
    import { usePayrollStore } from '@/stores/payroll';
    import { useMutation } from '@tanstack/vue-query';
    import axios from 'axios';
    import { toast } from 'vue-sonner';

    const { t } = useI18n();

    const payrollStore = usePayrollStore();

    const { mutate, isPending } = useMutation({
        mutationFn: (formData: { lunchArrangementMonthly: number }) =>
            axios.post(
                route('v2.salary.employee.lunch-arrangement.update', {
                    id: payrollStore.employeeId,
                }),
                formData,
            ),
        onSuccess: (data) => {
            toast.success(data.data.success || t('companies.save_success'));
            payrollStore.clearData();
        },
        onError: (error: any) => {
            console.log('error', error);
            toast.error(error.response.data.message || t('forms.system_error'));
        },
    });

    function update() {
        mutate({
            lunchArrangementMonthly: payrollStore.value,
        });
    }
</script>

<template>
    <AlertDialog
        :open="payrollStore.lunchArrangementMonthlyModalOpen"
        @update:open="(value) => payrollStore.toggleModal('lunch_arrangement_monthly', value)"
    >
        <AlertDialogContent>
            <AlertDialogHeader>
                <AlertDialogTitle>{{
                    t('payrolls.edit.lunch_arrangement_modal.title')
                }}</AlertDialogTitle>
                <AlertDialogDescription>
                    {{ t('payrolls.edit.lunch_arrangement_modal.body_1') }}
                    <span class="font-bold">{{ payrollStore.employeeName }},</span>
                    {{ t('payrolls.edit.lunch_arrangement_modal.body_2') }}
                </AlertDialogDescription>
            </AlertDialogHeader>
            <AlertDialogFooter>
                <AlertDialogCancel>{{
                    t('payrolls.edit.lunch_arrangement_modal.cancel')
                }}</AlertDialogCancel>
                <AlertDialogAction
                    variant="default"
                    :disabled="isPending"
                    @click="update"
                >
                    {{ t('payrolls.edit.lunch_arrangement_modal.confirm') }}
                </AlertDialogAction>
            </AlertDialogFooter>
        </AlertDialogContent>
    </AlertDialog>
</template>
